import React from "react";

import { Wrapper,Content,Vraagstyle } from "./Antwoord.styles";

 const Antwoord = ({vraag,antwoord,korrek,reg, colorone,colortwo}) =>(

    <Wrapper colorone={colorone} colortwo={colortwo}>
        <Content korrek={korrek} colorone={colorone} colortwo={colortwo}>
         <Vraagstyle korrek={korrek}>

           <div>
            {vraag} =          
            {antwoord}
           </div>

         </Vraagstyle>

         
           <div>
            {korrek?("korrek"):("verkeerd, die korrekte antwoord is " + reg )}
           </div>
           


        </Content>
    </Wrapper>

 );





export default Antwoord;